import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const ShopifyThemeEditor = (props: SvgProps) => (
  <Svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="32" height="32" rx="8" fill="#03AB8C" fillOpacity="0.05" />
    <rect
      x="0.25"
      y="0.25"
      width="31.5"
      height="31.5"
      rx="7.75"
      stroke="#03AB8C"
      strokeOpacity="0.2"
      strokeWidth="0.5"
    />
    <g clipPath="url(#clip0_8_4462)">
      <path
        d="M16.6665 12.6667L13.7999 9.80005C13.4988 9.50042 13.0913 9.33221 12.6665 9.33221C12.2418 9.33221 11.8343 9.50042 11.5332 9.80005L9.79987 11.5334C9.50024 11.8345 9.33203 12.242 9.33203 12.6667C9.33203 13.0915 9.50024 13.499 9.79987 13.8001L12.6665 16.6667M13.3332 12L14.6665 10.6667M19.9998 18.6667L21.3332 17.3334M19.3332 15.3334L22.1998 18.2C22.8265 18.8267 22.8265 19.84 22.1998 20.4667L20.4665 22.2C19.8398 22.8267 18.8265 22.8267 18.1998 22.2L15.3332 19.3334M17.9998 11.3334L20.6665 14M22.1158 12.5413C22.4683 12.1889 22.6663 11.7109 22.6664 11.2125C22.6664 10.7141 22.4685 10.2361 22.1161 9.88362C21.7637 9.53114 21.2858 9.33309 20.7874 9.33303C20.289 9.33297 19.8109 9.5309 19.4585 9.88328L10.5611 18.7826C10.4063 18.9369 10.2919 19.127 10.2278 19.3359L9.34713 22.2373C9.3299 22.2949 9.3286 22.3562 9.34336 22.4145C9.35813 22.4729 9.38841 22.5261 9.43099 22.5686C9.47358 22.6111 9.52687 22.6413 9.58523 22.656C9.64359 22.6707 9.70483 22.6693 9.76246 22.6519L12.6645 21.772C12.8732 21.7085 13.0632 21.5947 13.2178 21.4406L22.1158 12.5413Z"
        stroke="#03AB8C"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8_4462">
        <rect width="16" height="16" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </Svg>
);

export default ShopifyThemeEditor;
